import compareTypes from './types';

const compare = (map1, map2) => {

	if(!compareTypes(map1, map2)){
		return false;
	}

	if(map1 === null && map2 === null){
		return true;
	}

	const keys = {}
	let match = true;

	Object.keys(map1).forEach(key => {

		if(!match){
			return;
		}
		keys[key] = true;

		const value1 = map1[key];
		const value2 = map2[key];

		if(!map2.hasOwnProperty(key)){
			match = false;
			return;
		}

		if(typeof value1 == 'object'){
			if(!compareTypes(value1, value2)){
				match = false;
				return;
			}
			match = compare(value1, value2);
			return;
		}

		if(value1 !== value2){
			match = false;
		}
	});

	if(!match){
		return false;
	}

	Object.keys(map2).forEach(key => {

		if(!match || keys[key]){
			return;
		}
		keys[key] = true;

		const value1 = map1[key];
		const value2 = map2[key];

		if(!map2.hasOwnProperty(key)){
			match = false;
			return;
		}

		if(typeof value2 == 'object'){
			if(!compareTypes(value1, value2)){
				match = false;
				return;
			}
			match = compare(value1, value2);
			return;
		}

		if(value1 !== value2){
			match = false;
		}
	});

	return match;
}

export default compare;